











































































































































































































import Vue from 'vue'
import moment from 'moment'
import ReportForm from '@/components/ReportForm.vue'
import api, { ApiResponse } from '../../../../api'
import zones from '../../../../api/zones.json'
import {
  fetchReportMetadata,
  fetchReportList,
  deleteReport,
  getReportDownloadUrl,
  formatFileSize
} from '../../../../api/report-api'

export default Vue.extend({
  components: {
    ReportForm
  },

  data() {
    return {
      activeTab: 'history',
      tabs: [
        { key: 'history', text: 'Historique' },
        { key: 'disbursements', text: 'Décaissements' },
        { key: 'refunds', text: 'Remboursements' },
        { key: 'global', text: 'Globaux' },
        { key: 'ova', text: 'OVA' },
        { key: 'technical', text: 'Techniques' }
      ],
      exportFormat: 'xlsx',
      reportLoaders: {
        disbursements: {},
        refunds: {},
        global: {},
        ova: {},
        technical: {}
      },
      showSuccessAlert: false,
      currentMetadata: null as any,
      historyItems: [] as any[],
      historyTotal: 0,
      historyPage: 1,
      historyLimit: 20,
      historyTotalPages: 1,
      historyLoading: false,
      selectedIds: [] as string[],
      organizations: [] as { id: string; name: string }[]
    }
  },

  computed: {
    reports(this: any) {
      return [
        {
          tab: 'disbursements',
          title: 'Décaissements des SFD sur une période donnée',
          type: 'sfd_disbursement',
          filename: 'rapport_ligne_credit_sfd.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            },
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            }
          ]
        },
        {
          tab: 'disbursements',
          title:
            'Décaissements par département et commune sur une période donnée',
          type: 'state_and_common_disbursement',
          filename: 'rapport_credit_beneficiaires.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            },
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            }
          ]
        },
        {
          tab: 'disbursements',
          title: "Décaissements par secteur d'activités sur une période donnée",
          type: 'activity_sector_disbursement',
          filename: 'rapport_credit_beneficiaires.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'disbursements',
          title: 'Mise en place des crédits pour les bénéficiaires',
          type: 'beneficiary_dispatching',
          filename: 'rapport_credit_beneficiaires.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'choice',
              name: 'otm',
              label: 'OTM',
              items: [
                { text: 'Tous les OTM', value: '' },
                { text: 'MTN', value: 'mtn' },
                { text: 'MOOV', value: 'moov' }
              ]
            },
            {
              type: 'choice',
              name: 'state',
              label: 'Statut',
              items: [
                { text: 'Tous les statuts', value: '' },
                { text: 'Succès', value: 'paid' },
                { text: 'Échec', value: 'failed' },
                { text: 'En attente', value: 'pending' }
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Point des remboursements des SFD vers le FNM',
          type: 'credit_line_deadlines',
          filename: 'rapport_remboursements_sfd_to_fnm.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            },
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'choice',
              name: 'state',
              label: 'Statut',
              items: [
                { text: 'Tous les statuts', value: '' },
                { text: 'Succès', value: 'paid' },
                { text: 'Échec', value: 'failed' },
                { text: 'En attente', value: 'pending' }
              ]
            }
          ]
        },
        {
          tab: 'refunds',
          title:
            'Point des remboursements des groupes de bénéficiaires sur une période donnée',
          type: 'beneficiary_group_reimbursement',
          filename: 'rapport_remboursements_beneficiaires.csv',
          fields: [
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            },
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            // {
            //   type: 'choice',
            //   name: 'department',
            //   label: 'Département',
            //   class: 'capitalize',
            //   reset: ['common'],
            //   items: [
            //     { text: 'Tous les départements', value: '' },
            //     ...zones.map(d => ({ text: d.name, value: d.name }))
            //   ]
            // },
            // {
            //   type: 'choice',
            //   name: 'common',
            //   label: 'Commune',
            //   class: 'capitalize',
            //   items({ department }: { department: string }) {
            //     if (department) {
            //       return [
            //         { text: 'Toutes les communes', value: '' },
            //         ...(
            //           zones.find(d => d.name === department)?.communes || []
            //         ).map(c => ({ text: c.name, value: c.name }))
            //       ]
            //     }
            //     return [{ text: 'Toutes les communes', value: '' }]
            //   }
            // },
            // {
            //   type: 'choice',
            //   name: 'otm',
            //   label: 'OTM',
            //   items: [
            //     { text: 'Tous les OTM', value: '' },
            //     { text: 'MTN', value: 'mtn' },
            //     { text: 'MOOV', value: 'moov' }
            //   ]
            // },
            {
              type: 'choice',
              name: 'state',
              label: 'Statut',
              items: [
                { text: 'Tous les statuts', value: '' },
                { text: 'Succès', value: 'paid' },
                { text: 'Échec', value: 'failed' },
                { text: 'En attente', value: 'pending' }
              ]
            }
          ]
        },
        {
          tab: 'refunds',
          title:
            'Point de la balance âgée des remboursements des sfd vers le fnm',
          type: 'sfd_to_fnm_reimbursement_aged_balance',
          filename: 'rapport_impayes_beneficiaires.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title:
            'Point de la balance âgée des remboursements des bénéficiaires vers les sfd',
          type: 'beneficiary_to_sfd_reimbursement_aged_balance',
          filename: 'rapport_remboursement_sfd.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Point du tableau de bord',
          type: 'dashboard',
          filename: 'rapport_impayes_sfd.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Point du suivi mensuel des remboursements',
          type: 'monthly_reimbursement',
          filename: 'rapport_impayes_sfd.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Reporting sur les impayés',
          type: 'unpaid',
          filename: 'rapport_impayes.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'refunds',
          title: 'Reporting global',
          type: 'global',
          filename: 'rapport_global.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'global',
          title: 'Reporting global par groupe de bénéficiaire',
          type: 'global_by_beneficiary_group',
          filename: 'global_by_beneficiary_group.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'global',
          title: 'Reporting global par bénéficiaire',
          type: 'global_by_beneficiary',
          filename: 'global_by_beneficiary.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        // ========== RAPPORTS OVA ==========
        {
          tab: 'ova',
          title: "Chiffre d'affaires (CA)",
          type: 'ca',
          filename: 'rapport_ca.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'ova',
          title: 'Décaissements OVA',
          type: 'ova_disbursement',
          filename: 'rapport_ova_decaissements.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'ova',
          title: 'Remboursements OVA',
          type: 'ova_reimbursement',
          filename: 'rapport_ova_remboursements.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'ova',
          title: 'Réserves OVA',
          type: 'ova_reserve',
          filename: 'rapport_ova_reserves.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'disbursements',
          title: 'Décaissements par zone géographique',
          type: 'disbursement_by_zone',
          filename: 'rapport_decaissements_par_zone.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'disbursements',
          title: 'Rapport par zones',
          type: 'zone',
          filename: 'rapport_zones.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        // ========== RAPPORTS TECHNIQUES ==========
        {
          tab: 'technical',
          title: 'Transactions crédit OTM',
          type: 'otm_credits',
          filename: 'rapport_otm_credits.csv',
          fields: [
            {
              type: 'choice',
              name: 'otm',
              label: 'OTM',
              items: [
                { text: 'Tous', value: '' },
                { text: 'MTN', value: 'mtn' },
                { text: 'MOOV', value: 'moov' }
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'technical',
          title: 'Transactions débit OTM',
          type: 'otm_debits',
          filename: 'rapport_otm_debits.csv',
          fields: [
            {
              type: 'choice',
              name: 'otm',
              label: 'OTM',
              items: [
                { text: 'Tous', value: '' },
                { text: 'MTN', value: 'mtn' },
                { text: 'MOOV', value: 'moov' }
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'technical',
          title: 'Comptes virtuels',
          type: 'virtual_accounts',
          filename: 'rapport_comptes_virtuels.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: false,
              class: 'hidden'
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: false,
              class: 'hidden'
            }
          ]
        },
        {
          tab: 'technical',
          title: 'Transactions virtuelles',
          type: 'virtual_transactions',
          filename: 'rapport_transactions_virtuelles.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'technical',
          title: 'Commissions virtuelles',
          type: 'virtual_commissions',
          filename: 'rapport_commissions_virtuelles.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'technical',
          title: 'Dispatchings virtuels',
          type: 'virtual_dispatchings',
          filename: 'rapport_dispatchings_virtuels.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        },
        {
          tab: 'technical',
          title: 'Crédits de dispatching (non réussis)',
          type: 'dispatching_credits',
          filename: 'rapport_dispatching_credits_echecs.csv',
          fields: [
            {
              type: 'choice',
              name: 'organizationId',
              label: 'SFD',
              itemText: 'name',
              itemValue: 'id',
              items: [
                { name: 'Tous les SFDs', value: '' },
                ...this.organizations
              ]
            },
            {
              type: 'date',
              name: 'dateFrom',
              label: 'Date de début',
              required: true
            },
            {
              type: 'date',
              name: 'dateTo',
              label: 'Date de fin',
              required: true
            }
          ]
        }
      ]
    },

    displayedReports(this: any) {
      return this.reports.filter((report: any) => report.tab === this.activeTab)
    },

    allSelected(): boolean {
      return this.historyItems.length > 0 && this.historyItems.every((item: any) => this.selectedIds.includes(item.id))
    }
  },

  async created(this: any) {
    try {
      const { data } = await api.get('/organizations', {
        params: { type: 'sfd' }
      })
      this.organizations = (Array.isArray(data) ? data : data.result || [])
        .map((org: any) => ({ id: org.id, name: org.name }))
        .sort((a: any, b: any) =>
          a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase())
        )
    } catch (error) {
      this.$notify.error('Erreur lors du chargement de la liste des SFD')
    }

    if (this.activeTab === 'history') {
      this.loadHistory(1)
    }
  },

  watch: {
    activeTab(val: string) {
      if (val === 'history') {
        this.loadHistory(1)
      }
    }
  },

  methods: {
    formatFileSize,

    formatNumber(value: number): string {
      if (value == null) return '0'
      return value.toLocaleString()
    },

    formatDate(value: string | Date): string {
      if (!value) return '-'
      return moment(value).format('DD/MM/YYYY HH:mm')
    },

    loadHistory(page: number) {
      this.historyLoading = true
      this.selectedIds = []
      fetchReportList(page, this.historyLimit)
        .then((data) => {
          this.historyItems = data.items
          this.historyTotal = data.total
          this.historyPage = data.page
          this.historyTotalPages = data.totalPages
        })
        .catch((err) => {
          console.error('Failed to load history:', err)
        })
        .finally(() => {
          this.historyLoading = false
        })
    },

    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedIds = []
      } else {
        this.selectedIds = this.historyItems.map((item: any) => item.id)
      }
    },

    toggleItem(id: string) {
      const idx = this.selectedIds.indexOf(id)
      if (idx >= 0) {
        this.selectedIds.splice(idx, 1)
      } else {
        this.selectedIds.push(id)
      }
    },

    bulkDelete() {
      const count = this.selectedIds.length
      if (!confirm(`Supprimer définitivement ${count} rapport(s) ?`)) {
        return
      }
      this.historyLoading = true
      Promise.all(this.selectedIds.map((id) => deleteReport(id)))
        .then(() => {
          this.selectedIds = []
          this.loadHistory(1)
        })
        .catch((err) => {
          console.error('Bulk delete failed:', err)
          this.historyLoading = false
        })
    },

    downloadHistoryReport(item: any) {
      window.open(getReportDownloadUrl(item.id), '_blank')
    },

    deleteHistoryReport(item: any) {
      if (!confirm(`Supprimer définitivement le rapport "${item.title}" ?`)) {
        return
      }
      deleteReport(item.id)
        .then(() => {
          this.loadHistory(this.historyPage)
        })
        .catch((err) => {
          console.error('Failed to delete report:', err)
        })
    },

    statusClass(state: string): string {
      switch (state) {
        case 'completed':
          return 'bg-green-100 text-green-300'
        case 'running':
          return 'bg-orange-100 text-orange-300'
        case 'failed':
          return 'bg-red-100 text-red-300'
        default:
          return 'bg-gray-100 text-gray-700'
      }
    },

    stateLabel(state: string): string {
      switch (state) {
        case 'created':
          return 'Créé'
        case 'running':
          return 'En cours'
        case 'completed':
          return 'Terminé'
        case 'failed':
          return 'Échec'
        default:
          return state
      }
    },

    onGenerateReportClicked(
      this: any,
      options: Record<string, unknown>,
      report: any,
      index: number
    ) {
      Object.keys(options).forEach(key => {
        if (options[key] instanceof Date) {
          options[key] = moment(options[key] as Date).format('YYYY-MM-DD')
        }
      })

      //TODO Remove after recette
      if (
        ['balance_agee_sfd_to_fnm', 'balance_agee_beneficiary_to_sfd'].includes(
          report.type
        )
      )
        return
      this.$set(this.reportLoaders[this.activeTab], index, true)

      const { organizationId, dateFrom, dateTo, sendMail, ...filters } = options

      const reportParams = {
        type: report.type,
        title: report.title,
        format: this.exportFormat,
        productId: this.$route.params.productId,
        dateFrom,
        dateTo,
        organizationId: organizationId || undefined,
        filters
      }

      fetchReportMetadata(reportParams)
        .then((meta) => {
          this.currentMetadata = meta
        })
        .catch(() => {
          this.currentMetadata = null
        })
        .finally(() => {
          api
            .makeRequest({
              method: 'POST',
              url: 'reports',
              data: {
                ...reportParams,
                sendMail: true
              }
            })
            .then((response: ApiResponse) => {
              this.showSuccessAlert = true
              this.checkReportStatus(response.data, report.title, index)
            })
            .catch((err: any) => {
              console.error('Failed to generate report:', err)
              this.$notify.error('Erreur lors de la génération du rapport')
              this.$set(this.reportLoaders[this.activeTab], index, false)
            })
        })
    },

    checkReportStatus(this: any, report: any, title: string, index: number) {
      api
        .makeRequest({
          method: 'GET',
          url: `/reports/${report.id}`
        })
        .then((response: ApiResponse) => {
          if (response.isSuccessful) {
            // if (!['completed', 'failed'].includes(response.data.state)) {
            //   return setTimeout(() => {
            //     this.checkReportStatus(report, title, index)
            //   }, 5000)
            // }
            this.$set(this.reportLoaders[this.activeTab], index, false)

            if (response.data.state === 'completed') {
              api
                .download(
                  `/reports/${report.id}/download`,
                  {},
                  title.toUpperCase().replace(/ /g, '_') +
                    '_DU_' +
                    moment(report.dateFrom).format('DD_MM_YYYY') +
                    '_AU_' +
                    moment(report.dateTo).format('DD_MM_YYYY') +
                    '.' +
                    response.data.format
                )
                .then(() => {
                  this.$set(this.reportLoaders[this.activeTab], index, false)
                })
            } else if (response.data.state === 'failed') {
              this.$set(this.reportLoaders[this.activeTab], index, false)
            }
          }
        })
    }
  }
})
